import { LatLng } from "leaflet";

export function adjustPositionLeft(lat: number, lng: number, offsetMeters = 10): LatLng {
  // 1 grau de longitude ≈ 111km no equador
  // Ajuste aproximado: 0.0001 graus ≈ 11 metros
  const offset = offsetMeters / 111000;
  return new LatLng(lat, lng - offset);
}